var map = {
	"./IMG-20240803-WA0024.jpg": 7135,
	"./IMG-20240803-WA0052.jpg": 9648,
	"./IMG-20240803-WA0058.jpg": 2202,
	"./IMG-20240803-WA0060.jpg": 7063,
	"./IMG-20240803-WA0064.jpg": 8667,
	"./IMG-20240803-WA0066.jpg": 3913,
	"./IMG-20240803-WA0073.jpg": 1335,
	"./IMG-20240803-WA0074.jpg": 8674,
	"./IMG-20240803-WA0082.jpg": 9663,
	"./IMG-20240803-WA0087.jpg": 1718,
	"./IMG-20240803-WA0100.jpg": 6752,
	"./IMG-20240803-WA0102.jpg": 690,
	"./IMG-20240803-WA0107.jpg": 6915,
	"./IMG-20240803-WA0122.jpg": 9720,
	"./WhatsApp Image 2024-08-03 at 10.22.32_00c24b2a.jpg": 4319,
	"./WhatsApp Image 2024-08-03 at 10.53.15_9008d7d7.jpg": 2933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 876;